import { defineComponent as _defineComponent } from 'vue'
import AppIcon from '../../../ui/icon/AppIcon.vue'
import { IconSlug } from '@/v2/components/ui/icon/iconMap'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuOptionButton',
  props: {
  text: null,
  disabled: { type: Boolean, default: false },
  prependIcon: null,
  mini: { type: Boolean, default: false },
  truncate: { type: Boolean, default: false },
  isActive: { type: Boolean, default: false }
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;





return { __sfc: true,props, emit, AppIcon }
}

})